export default `
  ### Hvor vanlig er sængevæting?
  10-15% av barn i småskolealder, og cirka to i hver førsteklasse, sliter med problemet. Det er mer vanlig blant gutter.

  ### Når blir vanligvis barn tørre?
  De fleste (cirka 80%) er tørre ved 4-årsalderen, og det er som oftest nattbleia som forsvinner til slutt.

  ### Hvilke råd anbefales?
  Begrense drikke på kveldstid. ⅔ under dagen og ⅓ på ettermiddagen. Regelmessig dobesøk gjennom dagen (normalt 4-7). Dobesøk før sengetid. Begrense kullsyreholdig drikke og saltholdige måltider. Roe ned før sengetid uten skjermbruk.

  ### Hva er årsaken til sengevæting?
  Arvelighet. Obstipasjon. Normalt avføringsmønster er daglig til hver tredje dag. Blærekatarr. Hyppig vannlating med smerter/svie er de vanligste symptomene. Medisinsk. Tung og urolig søvn, overaktiv blære eller for stor urinproduksjon med lite antitissehormon på nattestid. En sjelden gang fordi barnet har mye å tenke på.

  ### Hva gjør problemet med barnet?
  Barn er forskjellige. For noen er dette en hemmelighet som kan påvirke barnets sosiale tilpasning og selvtillit. Avbrutt nattesøvn kan gi innvirkning på skoleprestasjonene.
`



// WEBPACK FOOTER //
// ./src/containers/Faq/faqs.js